import { render } from "./priceSlider.vue?vue&type=template&id=32f8d58c"
import script from "./priceSlider.vue?vue&type=script&lang=js"
export * from "./priceSlider.vue?vue&type=script&lang=js"

import "./priceSlider.vue?vue&type=style&index=0&id=32f8d58c&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__